<template>
  <div class="container step">
    <div class="group-container">
      <div class="group" v-for="(row,key) in dataRow" :key="key">
        <div class="content">
            {{row.title}}
        </div><!-- content end sub -->
        <div :class="'checkboxGroup' + ( row.half ? ' half' : '')">
          <div class="item" v-for="rows in row.checkbox" :key="rows.id">
            <input type="radio" @change="onChangeData(rows, row.keys)" :name="'s'+row.keys" :id="rows.id">
            <label :for="rows.id" class="text">
              <span class="checkboxText">{{rows.text}}</span>
              <textarea
              v-model="rows.remark"
              v-if="rows.text == '其他'" name="" placeholder="輸入文字"
              class="textarea" rows="4">
            </textarea>
            </label>
          </div>
        </div><!-- checkbox group end sub -->
      </div><!-- group end sub -->
    </div>
    <template>
      <router-link to="/step3" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link to="/step3-2" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'step1-1',
  data () {
    return {
      pageChage: false,
      props: ['result'],
      selectData: {
        'step3-1': {
          id: '',
          text: '',
          remark: ''
        },
        'step3-2': {
          id: '',
          text: '',
          remark: ''
        }
      },
      dataRow: [
        {
          keys: 'step3-1',
          title: '在臨床上,高齡mUC患者,對於化學治療的毒性比較不容易忍受,何種年紀會是您不會考慮停用Cisplatin治療的範圍?',
          half: true,
          checkbox: [
            {
              id: 's1-1',
              text: '60 歲~69歲',
              remark: ''
            },
            {
              id: 's1-2',
              text: '70 歲~79歲',
              remark: ''
            },
            {
              id: 's1-3',
              text: '80歲以上',
              remark: ''
            }
          ]
        },
        {
          keys: 'step3-2',
          title: '目前在臨床上對於”高齡”mUC患者,哪些因素會成為您治療上的考量要點？',
          half: false,
          checkbox: [
            {
              id: 's2-1',
              text: '用藥後疾病惡化時間長短',
              remark: ''
            },
            {
              id: 's2-2',
              text: '藥物治療後的存活率',
              remark: ''
            },
            {
              id: 's2-3',
              text: '藥物的毒性及副作用',
              remark: ''
            },
            {
              id: 's2-4',
              text: '其他',
              remark: ''
            }
          ]
        }
      ]
    }
  },
  methods: {
    onChangeData: function ($row, keys) {
      var val = this.selectData
      val[keys] = $row
      // console.log(this.selectData)
      if ((val['step3-1']['id'] !== '') && (val['step3-2']['id'] !== '')) {
        this.$emit('update:result', val)
        this.pageChage = true
      }
    }
  }
}
</script>

<style scoped>
  .container {text-align:center;}
  .container:before,
  .container:after {
    content:"";display:inline-block;
    vertical-align:middle;
    height:100%;width:0px;
  }
  .step .group .content {
    background:#73a5b9;
  }
  .step .checkboxGroup .item input[type='radio']:checked + .text:before {
    background:#73a5b9;border-color:#73a5b9;
  }
  a[class*="btn-"] {
    background:#73a5b9;color:white;
  }
</style>



// WEBPACK FOOTER //
// src/components/step3/question.vue